var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.667 2C1.747 2 1 2.768 1 3.714v4.572C1 9.232 1.746 10 2.667 10h6.666C10.253 10 11 9.232 11 8.286V3.714C11 2.768 10.254 2 9.333 2H2.667Zm1.145 2.11a.5.5 0 1 0-.624.78l2.5 2L6 7.14l.312-.25 2.5-2a.5.5 0 1 0-.624-.78L6 5.86 3.812 4.11Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.392a6be05a31bff9ae32941eba82e5c4.svg";
export { ForwardRef as ReactComponent };